<script lang="ts">
  import Button from "$components/+blocks/Button/Button.svelte";
  import OVIcon from "$components/+blocks/OVIcon/OVIcon.svelte";
  import ToolTip from "$components/+blocks/Tooltip/Tooltip.svelte";
  import Dialogue from "$components/+blocks/Dialogue/Dialogue.svelte";
  import { alerts } from "app/stores/alert";
  import { saveToClipboard } from "app/utils/clipboard";
  import { community } from "app/stores/community";
  import { Link, Refresh } from "$components/+blocks/OVIcon";

  let isNewLinkModalOpen: boolean = false;

  export let inviteLink: string;
  export let showGenerate: boolean;
  export let loading: boolean = false;
</script>

<div class="flex w-full items-center justify-between gap-2 pt-2 font-medium">
  {#if !loading}
    <div class="w-full">
      <ToolTip>
        <span slot="tip" class="text-sm font-semibold text-white">Click to copy</span>
        <div class="relative w-full grow cursor-pointer">
          <OVIcon
            icon={Link}
            class="pointer-events-auto absolute left-0.5 pt-3 pl-2 align-sub text-neutral-500 dark:text-neutral-300"
            size="size-7"
            on:click={() => {
              void saveToClipboard(inviteLink, alerts.add);
            }}
          />
          <input
            readOnly
            class="w-full cursor-pointer truncate rounded-md border bg-white py-2 pr-2 pl-8 text-sm text-neutral-500 hover:border-neutral-500 hover:bg-neutral-100 dark:border-white/10 dark:bg-neutral-700 dark:text-neutral-300 dark:hover:border-neutral-400 dark:hover:bg-white/5"
            data-test="invite-link"
            value={inviteLink}
            on:click={() => {
              void saveToClipboard(inviteLink, alerts.add);
            }}
          />
        </div>
      </ToolTip>
    </div>

    <!-- Generate new link button -->
    {#if showGenerate}
      <div class="whitespace-nowrap">
        <Button
          label="Generate new link"
          size="large"
          variant="primary"
          iconRight={Refresh}
          on:click={() => {
            isNewLinkModalOpen = true;
          }}
        />
      </div>
    {/if}
  {/if}

  <Dialogue
    title="Generate new link"
    message="Are you sure you want to generate a new invite link? Your existing link will expire and users will no longer be able to sign up with it"
    bind:open={isNewLinkModalOpen}
    confirmLabel="Generate"
    danger
    on:confirm={async () => {
      try {
        community.refreshInviteCode();
        void saveToClipboard(inviteLink, alerts.add, "Generated new invite link!");
      } catch (e) {
        alerts.error("Unable to generate new invite link. Please try again.");
      }
    }}
  />
</div>
